var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgChartDrawingStyleBar = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 16 16"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M8 1h1v4h2v1H9v7H8v-2H6v-1h2zM3 4h1v4h2v1H4v7H3v-2H1v-1h2zM14 3h-1v4h-2v1h2v5h1v-2h2v-1h-2z"
})));
export default SvgChartDrawingStyleBar;